package devxertech.com.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.pointerEvents
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onFocusOut
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.TextInput
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.required
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.opacity
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.events.SyntheticInputEvent
import org.w3c.dom.HTMLInputElement

@Composable
fun CustomTextInput(
    text: String,
    isMessageInput: Boolean,
    onTextChange: (String) -> Unit,
    placeholder: String,
    modifier: Modifier = Modifier,
    placeholderModifier: Modifier = Modifier,
) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var isFocused by remember { mutableStateOf(false) }
    Box(
        modifier = modifier.margin(top = if (breakpoint > Breakpoint.MD) 0.px else 25.px)
            .backgroundColor(sitePalette.contactLeft.rgb)
            .borderRadius(8.px)
            .border(
                1.px,
                LineStyle.Solid,
                if (isFocused)
                    sitePalette.primary.rgb
                else
                    sitePalette.contactLeft.rgb
            ),
        contentAlignment = Alignment.CenterStart
    ) {
        if (text.isEmpty()) {
            SpanText(text = placeholder, modifier = placeholderModifier)
        }
        TextInput(
            text = text,
            onTextChange = { onTextChange(it) },
            placeholder = "",
            modifier = Modifier.fillMaxSize()
                .border(0.px)
                .styleModifier {
                    property("outline", "none")
                    property("box-shadow", "none")
                }
                .fontSize(17.px).fontWeight(FontWeight.Medium)
                .fontFamily(Constants.FONT_FAMILY).lineHeight(86.px)
                .color(sitePalette.contactText.rgb)
                .cursor(Cursor.Pointer).padding(left = 22.px)
                .onFocusIn { isFocused = true }
                .onFocusOut { isFocused = false }
                .then(
                    if (isMessageInput) {
                        Modifier.padding(
                            bottom = if (breakpoint > Breakpoint.MD) 80.px else if (breakpoint == Breakpoint.MD) 70.px else 50.px,
                            left = 21.px
                        )
                    } else {
                        Modifier
                    }
                )
        )
    }
}

@Composable
fun UnderlinedTextField(
    value: String,
    onTextChange: (String) -> Unit,
    placeholder: String = "",
    nameAttr: String? = null,
    modifier: Modifier = Modifier,
    placeholderModifier: Modifier = Modifier,
) {
    val sitePalette = ColorMode.current.toSitePalette()
    Box(
        modifier = modifier
            .fillMaxWidth()
            .position(Position.Relative)
    ) {
        Box(modifier = Modifier.fillMaxWidth(),
            contentAlignment = Alignment.CenterStart) {
            if (value.isEmpty()) {
                SpanText(
                    text = placeholder,
                    modifier = placeholderModifier
                        .position(Position.Absolute)
                        .fontSize(18.px)
                        .lineHeight(37.px)
                        .color(Color.white)
                        .pointerEvents(PointerEvents.None)
                )
            }

            Input(
                type = if (nameAttr == "user_email") InputType.Email else InputType.Text,
                attrs = Modifier.fillMaxWidth()
                    .border(0.px)
                    .padding(left = 6.px)
                    .fontSize(18.px)
                    .lineHeight(36.px)
                    .outline(style = LineStyle.None)
                    .fontFamily(Constants.FONT_FAMILY)
                    .color(Colors.White)
                    .cursor(Cursor.Pointer)
                    .toAttrs {
                        value(value)
                        id("${nameAttr}_visible")
                        attr("autocomplete", "off")
                        attr("autocapitalize", "off")
                        onInput { event: SyntheticInputEvent<String, HTMLInputElement> ->
                            val inputVal = event.value

                            if (nameAttr == "user_email") {
                                onTextChange(inputVal.lowercase())
                            } else {
                                onTextChange(inputVal)
                            }
                        }
                        style {
                            property("background-color", "Transparent")
                            property("-webkit-box-shadow", "0 0 0px 1000px transparent inset")
                        }
                    }
            )

        }
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(Color.white)
                .transition(Transition.of(TransitionProperty.All, 300.ms))
                .position(Position.Absolute)
                .bottom(0.px)
        )
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(Color.darkblue)
                .transition(Transition.of(TransitionProperty.All, 300.ms))
                .position(Position.Absolute)
                .bottom(0.px)
                .scale(
                    if (value.isNotEmpty()) 1.0 else 0.0,
                    1.0
                )
        )
        if (!nameAttr.isNullOrBlank()) {
            Input(
                type = if (nameAttr == "user_email") InputType.Email else InputType.Text,
                attrs = {
                    name(nameAttr)
                    id(nameAttr)
                    value(value)
                    required(true)
                    attr("autocomplete", "off")
                    style {
                        position(Position.Absolute)
                        opacity(0)
                        pointerEvents(PointerEvents.None)
                        height(0.px)
                    }
                }
            )
        }
    }
}





